import { render } from "./DocumentIdCom.vue?vue&type=template&id=0d1336c2&scoped=true"
import script from "./DocumentIdCom.vue?vue&type=script&lang=js"
export * from "./DocumentIdCom.vue?vue&type=script&lang=js"

import "./DocumentIdCom.vue?vue&type=style&index=0&id=0d1336c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1336c2"]])

export default __exports__